import { render, staticRenderFns } from "./Reportcardmid.vue?vue&type=template&id=4e5cb23a"
import script from "./Reportcardmid.vue?vue&type=script&lang=js"
export * from "./Reportcardmid.vue?vue&type=script&lang=js"
import style0 from "./Reportcardmid.vue?vue&type=style&index=0&id=4e5cb23a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports